/* MaculaPM landing: doctor-video tiles (snippets/mpm-lp-video.liquid).
   Muted preview loops only while on screen; full clip plays in a dialog. */
(function () {
  if (window.mpmLpVideo) return;
  window.mpmLpVideo = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(video) {
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
  }

  var io = 'IntersectionObserver' in window && !reduceMotion
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !v.closest('[data-mpm-vid]').classList.contains('is-open')) {
            load(v);
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 })
    : null;

  function init(root) {
    if (root.dataset.mpmVidReady) return;
    root.dataset.mpmVidReady = '1';
    var tile = root.querySelector('.mpm-lp-vid__tile');
    var preview = root.querySelector('.mpm-lp-vid__preview');
    var dialog = root.querySelector('.mpm-lp-vid__dialog');
    var full = root.querySelector('.mpm-lp-vid__full');
    if (io) io.observe(preview);

    tile.addEventListener('click', function () {
      root.classList.add('is-open');
      preview.pause();
      load(full);
      if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      full.currentTime = 0;
      var p = full.play();
      if (p && p.catch) p.catch(function () {});
    });
    function close() {
      if (dialog.open) dialog.close();
    }
    root.querySelector('.mpm-lp-vid__close').addEventListener('click', close);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('close', function () {
      full.pause();
      root.classList.remove('is-open');
      tile.focus();
      if (io) { io.unobserve(preview); io.observe(preview); }
    });
  }

  function scan() {
    document.querySelectorAll('[data-mpm-vid]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
